'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _upperFirst = require('lodash/upperFirst');var _upperFirst2 = _interopRequireDefault(_upperFirst);

var _components = require('../../components');
var _cellGalleryParams = require('../../components/OMComponents/OMPropertyCells/components/CellGallery/cellGalleryParams');
var _ForeignSearchContainer = require('../ForeignSearchContainer/ForeignSearchContainer');

var _propertyDetails = require('../../redux/modules/propertyDetails');
var _foreignPropertySearch = require('../../redux/modules/foreignPropertySearch');



var _favoriteProperties = require('../../redux/modules/favoriteProperties');


var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');






var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _extractLocalisedData = require('../../helpers/extractLocalisedData');var _extractLocalisedData2 = _interopRequireDefault(_extractLocalisedData);
var _helpers = require('../ForeignPagePropertiesContainer/helpers');

var _ForeignPageCountryContainer = require('./ForeignPageCountryContainer.scss');var styles = _interopRequireWildcard(_ForeignPageCountryContainer);
var _capitalizeFirstLetter = require('../../helpers/capitalizeFirstLetter');var _capitalizeFirstLetter2 = _interopRequireDefault(_capitalizeFirstLetter);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
var ForeignPageCountryContainer = function (_Component) {_inherits(ForeignPageCountryContainer, _Component);function ForeignPageCountryContainer(props) {_classCallCheck(this, ForeignPageCountryContainer);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.












































    getLocation = function () {return _this.props.isProjects ? 'project_details' : 'home_details';};_this.

    clearAddress = function () {var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return address.replace(/-/gi, ' ');};_this.

    loadPropertiesData = function () {var additionalFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _this$props$searchQue =
      _this.props.searchQuery,sectionSearch = _this$props$searchQue.section,restSearch = _objectWithoutProperties(_this$props$searchQue, ['section']);
      var params = Object.assign({
        $limit: 10 },
      restSearch,
      additionalFilters);

      var requestType = params.section === 'projects' ? 'projects' : 'properties';var
      option = params.option,section = params.section,restParams = _objectWithoutProperties(params, ['option', 'section']);

      _this.props.searchForeignProperties({ requestType: requestType, params: params.section === 'projects' ? restParams : params });
      _this.props.countForeignProperties({
        requestType: requestType,
        params: (0, _omit2.default)(params.section === 'projects' ? restParams : params, ['$limit', '$skip']) });

    };_this.

    loadMoreProperties = function () {
      if (_this.props.propertiesIsLoading) {return;}var _this$state =
      _this.state,option = _this$state.optionTypes,sectionTypes = _this$state.sectionTypes;

      var params = {
        $skip: _this.props.searchQuery.$skip + _this.props.searchQuery.$limit,
        section: sectionTypes !== 'all' ? sectionTypes : null,
        option: option };


      _this.loadPropertiesData(params);
    };_this.

    openDetailsHandler = function (evt, propertyId) {var _evt$target =
      evt.target,classList = _evt$target.classList,parentElement = _evt$target.parentElement;

      var isFavoriteIcon = classList.contains('favoriteToggler');
      var isSwiperArrowIcon = classList.contains(_cellGalleryParams.swiperArrowClassName) ||
      parentElement.classList.contains(_cellGalleryParams.swiperArrowClassName);

      if (isFavoriteIcon || isSwiperArrowIcon) {return;}

      _this.openDetails(evt, propertyId);
    };_this.

    openDetails = function (evt, propertyId) {
      var location = _this.getLocation();
      var entityType = _this.props.isProjects ? _constants.ENTITY_TYPES.PROJECT : _constants.ENTITY_TYPES.PROPERTY;
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      location + '/' + propertyId);


      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        _reactRouter.browserHistory.push(route);
      } else {
        var modalRoute = '/' + _constants.ROUTES_PATHS.FOREIGN + '/' + _this.props.country;
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, modalRoute),
          query: { id: entityType + '_' + propertyId } });

        _this.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });
      }
    };_this.

    toggleFavorite = function (property) {var isProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;return (
        _this.props.toggleFavorite({ property: property, token: _this.props.userToken, isProject: isProject }));};_this.
    goToBack = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign'));};_this.

    handleOptionTypeChange = function (_ref) {var value = _ref.value;
      var query = {
        country: _this.clearAddress(_this.props.country),
        $skip: 0 };


      _this.setState({ optionTypes: value, sectionTypes: 'all' });

      if (value) {
        query.option = value;
        query.section = null;
      }

      _this.loadPropertiesData(query);
    };_this.

    handlesectionTypeChange = function (_ref2) {var value = _ref2.value;
      var query = {
        country: _this.clearAddress(_this.props.country),
        $skip: 0,
        option: _this.state.optionTypes };


      _this.setState({ sectionTypes: value });

      if (value !== 'all') {
        query.section = value;
      }

      _this.loadPropertiesData(query);
    };_this.

    renderProjectsList = function () {return (
        _react2.default.createElement('div', { className: styles.projectWrapper },
          _react2.default.createElement(_components.CountryProjectsList, {
            locale: _this.props.locale,
            translate: _this.props.translate,
            projects: _this.props.propertiesData,
            isMobile: _this.props.isMobile,
            isRtl: _this.props.isRtl,
            openDetailsPopup: _this.props.openDetailsPopup,
            hasMore: _this.props.hasNextPage,
            loadMore: _this.loadMoreProperties })));};_this.




    renderPropertiesList = function () {return (
        _react2.default.createElement(_components.CountryPropertiesList, {
          propertiesIsLoading: _this.props.propertiesIsLoading,
          propertysIsLoaded: _this.props.propertysIsLoaded,
          locale: _this.props.locale,
          translate: _this.props.translate,
          properties: _this.props.isFavorites ? _this.props.favoritesData : _this.props.propertiesData,
          handleClick: _this.openDetailsHandler,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl,
          toggleFavorite: _this.toggleFavorite,
          favoriteProperties: _this.props.favoriteProperties,
          isProjects: _this.props.isProjects,
          openDetailsPopup: _this.props.openDetailsPopup,
          hasMore: _this.props.hasNextPage,
          loadMore: _this.loadMoreProperties }));};_this.



    renderTitle = function () {var _this$props =
      _this.props,translate = _this$props.translate,searchedAddress = _this$props.searchedAddress,locale = _this$props.locale,country = _this$props.country;var _ref3 =
      (0, _extractLocalisedData2.default)(searchedAddress || {}, locale) || {},_ref3$country_name = _ref3.country_name,countryTitle = _ref3$country_name === undefined ? '' : _ref3$country_name;
      if (!countryTitle) {
        countryTitle = country && country.split(' ').map(function (word) {return (0, _capitalizeFirstLetter2.default)(word);}).join(' ');
      }

      var translation = translate('foreignProperties', 'propertyIn');

      var replacers = [
      { reg: /%s/, val: countryTitle }];

      var title = replacers.reduce(function (acc, item) {return acc.replace(item.reg, item.val);}, translation);

      return (
        _react2.default.createElement('h2', null, (0, _upperFirst2.default)(title.trim())));

    };_this.

    renderPropertyTypeLink = function (_ref4) {var value = _ref4.value,label = _ref4.label;
      var pathname = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      _constants.ROUTES_PATHS.FOREIGN + '/' + _this.props.country + '/' + _constants.ROUTES_ADDITIONAL.FOREIGN_SEARCH);

      var query = { type: [value], option: _constants.optionTypes.buy };

      return (
        _react2.default.createElement(_reactRouter.Link, { className: styles.propertyTypeLink, key: value, to: { pathname: pathname, query: query } }, label));

    };_this.

    renderOptionTypeDropdown = function () {
      var optionsConfig = (0, _ForeignSearchContainer.getOptionsFilter)(_this.props.translate('search_box')).
      map(function (item) {return Object.assign({}, item, { label: _react2.default.createElement('span', null, item.label) });});

      var optionsBuyConfig = (0, _ForeignSearchContainer.getOptionsBuyFilter)(_this.props.translate('search_box')).
      map(function (item) {return Object.assign({}, item, { label: _react2.default.createElement('span', null, item.label) });});

      var optionsRentConfig = (0, _ForeignSearchContainer.getOptionsRentFilter)(_this.props.translate('search_box')).
      map(function (item) {return Object.assign({}, item, { label: _react2.default.createElement('span', null, item.label) });});

      return (
        _react2.default.createElement('div', { className: styles.filtersChipWrapper },
          _react2.default.createElement(_components.OptionTypeChipsDropdown, {
            options: optionsConfig,
            selectedValue: _this.state.optionTypes,
            handleChange: _this.handleOptionTypeChange }),

          _react2.default.createElement(_components.OptionTypeChipsDropdown, {
            options: _this.state.optionTypes === 'buy' ? optionsBuyConfig : optionsRentConfig,
            selectedValue: _this.state.sectionTypes,
            handleChange: _this.handlesectionTypeChange })));



    };_this.

    renderFiltersChips = function () {return (
        _react2.default.createElement('div', { className: styles.filterChips },
          _this.renderOptionTypeDropdown()));};_this.



    renderBack = function () {return (
        _react2.default.createElement('div', {
            className: styles.backWrapper,
            onClick: _this.goToBack },

          _react2.default.createElement('i', { className: 'icon icon-back' }),
          _react2.default.createElement('p', null, _this.props.translate('header', 'foreign'))));};_this.state = { propertyTypes: (0, _helpers.getPropertyTypesValues)(props.translate), optionTypes: 'buy', sectionTypes: 'all' };return _this;}ForeignPageCountryContainer.prototype.componentDidMount = function componentDidMount() {if (!this.props.isFavorites && !this.props.propertiesIsLoading) {this.loadPropertiesData({ country: this.clearAddress(this.props.country), $skip: 0, option: this.state.optionTypes });}};ForeignPageCountryContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var countryWasChanged = nextProps.country !== this.props.country;if (countryWasChanged && !nextProps.propertiesIsLoading) {this.loadPropertiesData({ country: this.clearAddress(nextProps.country), $skip: 0, option: this.state.optionTypes });}if (nextProps.locale !== this.props.locale) {var stateModifier = {};stateModifier.propertyTypes = (0, _helpers.getPropertyTypesValues)(nextProps.translate);this.setState(Object.assign({}, stateModifier));}if (!nextProps.isDetailsModalOpen && this.props.isDetailsModalOpen) {var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),_browserHistory$getCu2 = _browserHistory$getCu.pathname,pathname = _browserHistory$getCu2 === undefined ? '/' + _constants.ROUTES_PATHS.FOREIGN + '/' + this.props.country : _browserHistory$getCu2;_reactRouter.browserHistory.push({ pathname: pathname, query: {} });}};ForeignPageCountryContainer.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapper) },






        _react2.default.createElement('div', { className: styles.content },
          this.renderBack(),
          this.renderTitle(),
          this.renderFiltersChips(),
          this.state.sectionTypes === 'projects' ?
          this.renderProjectsList() :
          this.renderPropertiesList())));




  };return ForeignPageCountryContainer;}(_react.Component);


ForeignPageCountryContainer.propTypes = {
  country: _propTypes2.default.string,
  searchedAddress: _propTypes2.default.object,
  isFavorites: _propTypes2.default.bool,
  isProjects: _propTypes2.default.bool,
  additionalFilters: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  propertiesIsLoading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  searchQuery: _propTypes2.default.object,
  hasNextPage: _propTypes2.default.bool,
  propertiesData: _propTypes2.default.array,
  propertiesCount: _propTypes2.default.number,
  // hasNextPage: PropTypes.bool,
  favoritesData: _propTypes2.default.array,
  searchForeignProperties: _propTypes2.default.func,
  countForeignProperties: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  isDetailsModalOpen: _propTypes2.default.bool,
  propertysIsLoaded: _propTypes2.default.bool,
  foreignPropertySearch: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state, props) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    searchQuery: state.foreignPropertySearch.query || {},
    hasNextPage: (0, _get2.default)(state, 'foreignPropertySearch.meta.hasNextPage'),
    propertiesData: state.foreignPropertySearch.data || [],
    propertiesCount: state.foreignPropertySearch.count,
    propertiesIsLoading: state.foreignPropertySearch.loading,
    propertysIsLoaded: state.foreignPropertySearch.loaded,
    foreignPropertySearch: state.foreignPropertySearch,
    searchedAddress: (0, _get2.default)(state, 'foreignPropertySearch.searchedAddress'),
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    favoritesData: props.isFavorites ? state.favoriteProperties.favoritesData || [] : null,
    favoriteProperties: state.favoriteProperties.favoriteIDs || [],
    isDetailsModalOpen: state.propertyDetails.isDetailsModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  searchForeignProperties: _foreignPropertySearch.searchForeignProperties,
  countForeignProperties: _foreignPropertySearch.countForeignProperties,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  openDetailsPopup: _propertyDetails.openDetailsPopup })(
ForeignPageCountryContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPageCountryContainer/ForeignPageCountryContainer.js
// module id = 2942
// module chunks = 0